import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { DeterminationModel } from 'src/app/shared/model/Determination.model';
import { BaseService } from '../base.service';
import { IAppConfig } from '../Config/app-config.model';

@Injectable({
  providedIn: 'root'
})
export class DeterminationService extends BaseService {

  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
  }

  GetDeterminations(): Observable<DeterminationModel[]> {
    return this.Get<DeterminationModel[]>(`${this.configParam.ApiConfig.API_ENDPOINT}Determination`);
  }
}
